<div class="container flex">
  <div class="block-icon flex column">
    <div class="shows-counter">
      <div></div>
      <div class="counter">{{ vm.showsCount }}</div>
    </div>
  </div>
  <div class="name-editor flex column">
    <div
      class="flex row field text-editor"
      #editableName
      contenteditable="true"
      (input)="vm.name = editableName.textContent"
      (blur)="vm.saveBlock()"
      (keydown.enter)="$event.preventDefault()"
      (paste)="vm.handleContentEditablePaste($event)"
    >
      {{ vm.name }}
    </div>
    <div class="flex row field title">BLOCK NAME</div>
  </div>
  <div class="duration flex column">
    <div class="flex row field">{{ vm.durationAsText }}</div>
    <div class="flex row field title">BLOCK DURATION</div>
  </div>
  <div class="actions flex row justify-end" [hidden]="vm.loadingBlock">
    <div class="flex row" style="align-items: center; margin-right: 50px">
      <evrideo-tot-sliding-toggle
        [this]="'Block'"
        [that]="'Stack'"
        [textColor]="'#fff'"
        [toggleBorderColor]="'#fff'"
        [toggleBallColor]="'#fff'"
        [default]="isBlockStack ? 'that' : 'this'"
        [disabled]="vm.isBlockStackDisabled"
        [disabledTooltip]="
          'Can\'t change block type if stack includes graphics'
        "
        (its)="BlockStackToggleChange($event)"
      ></evrideo-tot-sliding-toggle>
    </div>
    <evrideo-copy-button
      title="DUPLICATE"
      class="flex column action"
      [hoverClass]="'white-hover-white'"
      (click)="vm.duplicateBlock()"
    ></evrideo-copy-button>
    <remove-button
      data-title="DELETE"
      [overrideClass]="'white-hover-white'"
      (click)="vm.removeBlock()"
      class="flex column action"
    ></remove-button>
  </div>
</div>
